// event management
export const eventListApi = 'institute-management/event-management/list'
export const eventStoreApi = 'institute-management/event-management/store'
export const eventDetailsApi = 'institute-management/event-management/details'
export const eventUpdateApi = 'institute-management/event-management/update'

// employee management
export const employeeListApi = 'institute-management/employee-management/list'
export const employeeStoreApi = 'institute-management/employee-management/store'
export const employeeDetailsApi = 'institute-management/employee-management/details'
export const employeeUpdateApi = 'institute-management/employee-management/update'
export const employeeToggleStatusApi = 'institute-management/employee-management/toggle-status'

// budget allocation
export const budgetAllocationListApi = 'institute-management/budget-allocation/list'
export const budgetAllocationStoreApi = 'institute-management/budget-allocation/store'
export const budgetAllocationDetailsApi = 'institute-management/budget-allocation/details'
export const budgetAllocationUpdateApi = 'institute-management/budget-allocation/update'
export const budgetAllocationToggleStatusApi = 'institute-management/budget-allocation/toggle-status'

// transportation management
export const transportationManagementListApi = 'institute-management/transportation-management/list'
export const transportationManagementStoreApi = 'institute-management/transportation-management/store'
export const transportationManagementUpdateApi = 'institute-management/transportation-management/update'
export const transportationManagementToggleStatusApi = 'institute-management/transportation-management/toggle-status'

export const transportationManagementEditApi = 'institute-management/transportation-management/edit'
export const transportationManagementDetailApi = 'institute-management/transportation-management/show'
// institute management
export const instituteListApi = 'institute-management/institution-profile-management/list'
export const instituteStoreApi = 'institute-management/institution-profile-management/store'
export const instituteToggleStatusApi = 'institute-management/institution-profile-management/toggle-status'
export const instituteUpdateApi = 'institute-management/institution-profile-management/update'
// request form
export const requestFormListApi = 'institute-management/request-form/list'
export const requestFormStoreApi = 'institute-management/request-form/store'
export const requestFormToggleStatusApi = 'institute-management/request-form/toggle-status'
export const requestFormUpdateApi = 'institute-management/request-form/update'
// vendor
export const vendorListApi = 'institute-management/vendor/list'
export const vendorStoreApi = 'institute-management/vendor/store'
export const vendorToggleStatusApi = 'institute-management/vendor/toggle-status'
export const vendorUpdateApi = 'institute-management/vendor/update'

// Resource Management
export const ResourceManagementListApi = 'institute-management/resource-management/list'
export const ResourceManagementStoreApi = 'institute-management/resource-management/store'
export const ResourceManagementUpdateApi = 'institute-management/resource-management/update'
export const ResourceManagementToggleStatusApi = 'institute-management/resource-management/toggle-status'

// Course Management
export const courseManagementListApi = 'institute-management/course-management/list'
export const courseManagementStoreApi = 'institute-management/course-management/store'
export const courseManagementShowApi = 'institute-management/course-management/show'
export const courseManagementToggleStatusApi = 'institute-management/course-management/toggle-status'

// Book Management
export const bookListApi = 'institute-management/library-book-list/list'
export const bookStoreApi = 'institute-management/library-book-list/store'
export const bookToggleStatusApi = 'institute-management/library-book-list/toggle-status'

// Committee Management
export const committeeListApi = 'institute-management/committee-management/list'
export const committeeStoreApi = 'institute-management/committee-management/store'
export const committeeUpdateApi = 'institute-management/committee-management/update'
export const committeeToggleApi = 'institute-management/committee-management/toggle-status'
// Library Book Distribution
export const LibraryBookDistributionListApi = 'institute-management/library-book-distribution/list'
export const LibraryBookDistributionStoreApi = 'institute-management/library-book-distribution/store'
export const LibraryBookDistributionBookListApi = 'institute-management/library-book-distribution/booklist'
export const LibraryBookDistributionStudentListApi = 'institute-management/library-book-distribution/studentlist'
export const LibraryBookDistributionUpdateApi = 'institute-management/library-book-distribution/update'
export const LibraryBookDistributionToggleStatusApi = 'institute-management/library-book-distribution/toggle-status'

// Library Book Receive
export const LibraryBookReceiveListApi = 'institute-management/library-book-receive/list'
export const LibraryBookReceiveStoreApi = 'institute-management/library-book-receive/store'
export const LibraryBookReceiveUpdateApi = 'institute-management/library-book-receive/update'
export const LibraryBookReceiveShowApi = 'institute-management/library-book-receive/show'
export const LibraryBookReceiveBookListApi = 'institute-management/library-book-receive/booklist'
export const LibraryBookReceiveStudentListApi = 'institute-management/library-book-receive/studentlist'

// Teacher & Stuff Assign
export const getTeacherStuffAssignList = 'institute-management/assign-teacher-stuff/getTeacherStuffAssignList'
export const getTeacherStuffApi = 'institute-management/assign-teacher-stuff/getteacherstuff'
export const teacherStuffAssingApi = 'institute-management/assign-teacher-stuff/teacherStuffAssign'
export const teacherStuffAssingUpdateApi = 'institute-management/assign-teacher-stuff/update'

// Teacher & Stuff Attendance
export const attendanceTeacherStuffList = 'institute-management/attendance-teacher-stuff/attendanceTeacherStuffList'
export const getListTeacherStuff = 'institute-management/attendance-teacher-stuff/getListTeacherStuff'
export const teacherStuffAttendance = 'institute-management/attendance-teacher-stuff/teacherStuffAttendance'
export const teacherStuffAttendanceUpdate = 'institute-management/attendance-teacher-stuff/update'
